import "@/App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import Admin from "./pages/Admin";
import Colaboradores from "./pages/Colaboradores";
import BibliotecaPublica from "./pages/BibliotecaPublica";
import GiraPublica from "./pages/GiraPublica";

function App() {
  return (
    <div className="App">
      <HashRouter>
        <Toaster richColors position="top-center" />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/colaboradores" element={<Colaboradores />} />
          <Route path="/biblioteca" element={<BibliotecaPublica />} />
          <Route path="/gira" element={<GiraPublica />} />
        </Routes>
      </HashRouter>
    </div>
  );
}

export default App;
